<main class="bg-white position-relative">
  <!-- Download the payouttt App -->
  <section class="position-relative download_payouttt-app" id="download_payouttt_sec">
    <div class="download_payouttt_container">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="download_moile_screen position-absolute">
              <img alt="" class="light-img img-fluid" src="/assets/images/app-mobile-img.png"/>
              <img alt="" class="dark-img img-fluid" src="/assets/images/dark-mobile.png"/>
            </div>
          </div>
          <div class="col-md-7">
            <div class="download-payoutt">
              <h3 class="text-left oswald_font bold_600 font_44 text-uppercase" style="color:#272727">Download
                the QuickKicks App</h3>
              <div class="rating_list mt-sm-4 py-lg-2">
                                    <span class="pl-0"><i aria-hidden="true"
                                                          class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-1"><i aria-hidden="true"
                                      class="fa fa-star font_20" style="color:gold"></i></span>
                <span class="pl-2 open_sans bold_600 font_18" style="color:#272727">4.9</span>
              </div>
              <div class="app_list mt-md-4 mt-xl-4 pt-xl-2">
                <ul class="pl-0 mb-0">
                  <li
                    class="open_sans bold_600 font_18 position-relative pl-2 pl-sm-4 mb-1 mb-xl-2 mb-lg-0" style="color:#272727">
                    Buy and sell authentic sneakers, from
                    your pocket.
                  </li>
                </ul>
              </div>
              <div class="app_link_downloads d-flex align-items-center mt-md-5 mt-2">
                <a href="javascript:void(0);" target="_blank">
                  <img alt="" class="img-fluid" src="/assets/images/google_play-app.png"/>
                </a>
                <a class="ml-2 ml-lg-5 ml-md-4" href="javascript:void(0);" target="_blank">
                  <img alt="" class="img-fluid" src="/assets/images/app_store-img.png"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
